import {HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from "@angular/common/http";
import {inject} from "@angular/core";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {AlertDialogService} from '../dialog/alert-dialog/alert-dialog.service';

export const IGNORE_422_ERROR = new HttpContextToken<boolean>(() => false);

export function http422Interceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const alertDialogService = inject(AlertDialogService);

  if (req.context.get(IGNORE_422_ERROR)) {
    return next(req)
  }
  return next(req).pipe(tap(event => {
  }, err => {
    handleError(err, alertDialogService);
  }));
}

function handleError(err: HttpErrorResponse, alertDialogService: AlertDialogService) {
  if (err.status === 422) {
    alertDialogService.open({
      type: 'danger',
      isInnerHTML: true,
      title: 'แจ้งเตือน',
      content: `<div class="text-center">
                    <div class="fw-semibold text-body-secondary mb-2">เกิดข้อผิดพลาดที่เซิร์ฟเวอร์</div>
                    <div>รหัสอ้างอิง: <span class="fw-semibold text-danger">${err.error?.referenceCode}</span></div>
                </div>`,
      confirmButtonMsg: 'ปิด'
    });
  }
}
